import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getDetailsAction } from '../actions';

const {
  useLoader: useWarningsSummaryDetailsLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getDetailsAction,
});

function StudentWarningsSummaryDetailsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export { StudentWarningsSummaryDetailsLoader, useWarningsSummaryDetailsLoader };
